module.exports = __webpack_public_path__ + "images/restyling-1-994ba4929dc934c09177dd895ef2d1b7.jpg";